import { useState } from 'react';
import { MapPreferenceControl } from './MapPreferenceControl';

const STORAGE_KEY = 'dragonfly-cookie-notice-v1';

export function CookieNotice({
  detailsOpen,
  onCloseDetails,
}: {
  detailsOpen: boolean;
  onCloseDetails: () => void;
}) {
  const [acknowledged, setAcknowledged] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === 'acknowledged';
    } catch {
      return false;
    }
  });
  const open = !acknowledged || detailsOpen;
  if (!open) return null;
  const close = () => {
    try {
      localStorage.setItem(STORAGE_KEY, 'acknowledged');
    } catch {
      // Dismissal still works for this page when browser storage is unavailable.
    }
    setAcknowledged(true);
    onCloseDetails();
  };
  return (
    <aside className="cookie-notice" aria-label="Cookie details">
      <div>
        <strong>Only necessary cookies</strong>
        <p>
          We use cookies for secure sign-in and to let you manage a personal calendar feed. There is
          no advertising or analytics tracking by this app. Optional maps load when you choose Show
          map or enable automatic loading in Cookie details; the map provider may use its own
          cookies.
        </p>
        {detailsOpen && <MapPreferenceControl />}
        <a href="/privacy">Privacy Policy</a>
      </div>
      <button className="button button-small" onClick={close}>
        Got it
      </button>
    </aside>
  );
}
